import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import printBaggageSticker from '../../../../utils/printers/ItemTicket';
import { flagPrintBaggageVoucher } from '../../../../actions';

const PrintItemsStickerButton = ({ baggage, dispatchFlagPrintBaggageVoucher, printOnMount }) => {
  const handleClick = async () => {
    dispatchFlagPrintBaggageVoucher(true)
    await printBaggageSticker(baggage.toJS());
    setTimeout(()=>{dispatchFlagPrintBaggageVoucher(false)},3000)

  };

  return (
    <Button color="light" className="border" onClick={handleClick} disabled={printOnMount}>
      <i className={`fa ${printOnMount ? "fa-spinner" : "fa-print"}`} /> Stickers de Equipaje
    </Button>
  );
};

PrintItemsStickerButton.propTypes = {
  baggage: PropTypes.instanceOf(Map).isRequired,
  dispatchFlagPrintBaggageVoucher: PropTypes.func.isRequired,
  printOnMount: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BaggageUnit }) => ({
  baggage: BaggageUnit.Baggage.getIn(['current', 'content']),
  printOnMount: BaggageUnit.Baggage.getIn(['current', 'printOnMount']),
});

const mapDispatchToProps = {
  dispatchFlagPrintBaggageVoucher: flagPrintBaggageVoucher,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintItemsStickerButton);